import Model from '@/app/Model'
import { Plan } from '@/models/Plan'
import { User } from '@/models/User'
// import { Module } from '@/models/Module'

export class Department extends Model {
	static fields () {
		return {
			id: null,
			name: null,
			companyId: null,
			company: {
				name: null,
				id: null
			},
			plan: Plan,
			manager: User,
			billingDetails: null,
			country: null,
			city: null,
			tasksFlowEnabled: null,
			address: null, // deprecated, remove after some time
			street1: null,
			street2: null,
			postalCode: null,
			description: null,
			workingHours: null,
			addresses: null,
			primaryAddress: null,
			phoneNumber: null,
			email: null,
			accountantEmail: null,
			usersCount: 0,
			turnover: 0,
			ordersCount: 0,
			soldParts: 0,
			commission: null,
			vehicleType: null,
			debt: 0,
			shipmentsEnabled: null,
			partsQuantityEnabled: null,
			ruByShippingEnabled: null,
			notificationEmail: null,
			rrrEnabled: null,
			billingManagementEnabled: null,
			ebayAspectsEnabled: null,
			numberPlatesSearchEnabled: null,
			apiHubEnabled: null,
			teilehaberEnabled: null,
			autoteileMarktEnabled: null,
			locationGroupEnabled: null,
			oemPartsEnabled: null,
			groupedSaleLimitingEnabled: null,
			returningShipmentsEnabled: null,
			fitmentsEnabled: null,
			ebayFitmentsEnabled: null,
			partAnalyticsEnabled: null,
			vinProcessingEnabled: null,
			aiImageProcessingEnabled: null,
			conditionType: null,
			qualityType: null,
			debtLimit: 0,
			billableVat: null,
			public: null,
			dalysltVat: 0,
			shipmentsAccount: {
				enabledCouriers: []
			},
			currency: null
		}
	}
	static hasMany () {
		return {
			// modules: Module
		}
	}
}

export function createDepartment (data) {
	return Object.freeze(new Department(data))
}
